// extracted by mini-css-extract-plugin
export var optionGrid = "_b5-7";
export var optionList = "_b5-6";
export var questionsBlock = "_b5-9";
export var spacer = "_b5-5";
export var stepCenteredContent = "_b5-3";
export var stepInner = "_b5-0";
export var stepInnerFullWidth = "_b5-1";
export var stepInnerLockScroll = "_b5-2";
export var stepTransitionFrame = "_b5-4";
export var welcomeBlock = "_b5-8";